import * as pc from 'playcanvas';

import type { Transform } from './scene-types';

/**
 * Apply a schema `Transform` to an entity, falling back to identity for any
 * missing field. The schema uses Euler angles in degrees (XYZ order), which
 * is what PlayCanvas's `setLocalEulerAngles` already expects.
 */
export function applyTransform(entity: pc.Entity, t?: Transform): void {
    if (t?.position) {
        entity.setLocalPosition(t.position[0], t.position[1], t.position[2]);
    } else {
        entity.setLocalPosition(0, 0, 0);
    }
    if (t?.rotation) {
        entity.setLocalEulerAngles(t.rotation[0], t.rotation[1], t.rotation[2]);
    } else {
        entity.setLocalEulerAngles(0, 0, 0);
    }
    if (t?.scale) {
        entity.setLocalScale(t.scale[0], t.scale[1], t.scale[2]);
    } else {
        entity.setLocalScale(1, 1, 1);
    }
}
